// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  /** Logs de diagnóstico para push (FCM / permisos). Desactivar en builds de producción. */
  debugPush: true,
  // apiUrl: 'http://local.agendate:3000',
  // apiUrl2: 'http://local.agendateapp.com:7000',
  /** Vacío en dev: las peticiones a APIMAIN pasan por proxy.conf.json y evitan CORS. */
  apiUrl: 'https://qa.agendateapp.com',
  APIMAIN: '/agendate.main.ms',
  // Firebase configuration
  // TODO: Reemplazar con tus credenciales de Firebase Console
  firebase: {
    apiKey: "AIzaSyDIco-CxMHdghcb460VvVUkYC1uLMo7KCM",
    authDomain: "agendateapp-f4e1e.firebaseapp.com",
    projectId: "agendateapp-f4e1e",
    storageBucket: "agendateapp-f4e1e.firebasestorage.app",
    messagingSenderId: "17540333641",
    appId: "1:17540333641:web:64e51d528d51962fe9bf98",
    vapidKey: "BMCz4A0P7TEqvj1I3JcC91hVsrZrsiHlPCp9JaAZsbea98mpES3xhYpVuDS4bBYaCnBWq8kPdB3YCK-QAPYjOtE",
    measurementId: "G-MFSNNBG26V"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
